import * as React from 'react';
import Svg, { SvgProps, G, Rect, Path } from 'react-native-svg';

function SvgComponent(props: SvgProps) {
  return (
    <Svg width={27} height={38} {...props}>
      <G fill="#FFF" fillRule="evenodd">
        <Rect x={12.79} width={1.854} height={12.049} rx={0.927} />
        <Path d="M9.415 11.735c.544.494 1.57 1.472 3.078 2.934a2 2 0 002.799-.015l.327-.324c.964-.952 1.78-1.748 2.449-2.39 5.141 1.887 8.81 6.825 8.81 12.621C26.878 31.983 20.861 38 13.439 38S0 31.983 0 24.561c0-6.02 3.959-11.116 9.415-12.826zm10.846 11.24H6.632v1.592h3.908v.315c-.063 1.544-.378 2.788-.977 3.765-.599.883-1.733 1.639-3.435 2.238l.883 1.386c1.764-.614 3.025-1.48 3.813-2.584.803-1.197 1.244-2.804 1.323-4.805v-.315h2.332v5.672c0 1.15.551 1.733 1.67 1.733h2.505c.552 0 .961-.173 1.245-.489.284-.33.488-1.386.599-3.167l-1.481-.472c-.032 1.276-.11 2.048-.22 2.3-.095.237-.253.363-.442.363h-1.733c-.363 0-.536-.205-.536-.615v-5.325h4.175v-1.592zm-1.37-4.616H7.86v1.575h11.03V18.36z" />
        <Path d="M21.068 5.055a.874.874 0 01-.088 1.146l-6.554 6.432a.876.876 0 01-.654.25.875.875 0 01-.653-.25L6.565 6.201a.874.874 0 01-.01-1.238.878.878 0 011.24-.01l5.978 5.866 5.977-5.866a.878.878 0 011.15-.069l.09.08.001.001z" />
      </G>
    </Svg>
  );
}

const RedeemIconOn = React.memo(SvgComponent);
export default RedeemIconOn;
